function smoothScrollTo(top, duration = 500) {
    const start = window.scrollY;
    const startTime = performance.now();
    function animate(time) {
        const progress = Math.min((time - startTime) / duration, 1);
        const ease =
            progress < 0.5
                ? 2 * progress * progress
                : 1 - Math.pow(-2 * progress + 2, 2) / 2;
        window.scrollTo(0, start + (top - start) * ease);
        if (progress < 1) requestAnimationFrame(animate);
    }
    requestAnimationFrame(animate);
}

function scrollToHash() {
    const hash = decodeURIComponent(location.hash.slice(1));
    if (!hash) return;
    const target = document.getElementById(hash);
    if (!target) return;
    const stickyH = document.body.classList.contains("fullPage") ? 0 : 114;
    const offset =
        target.getBoundingClientRect().top + window.scrollY - stickyH;
    smoothScrollTo(offset);
}

window.addEventListener("load", () => {
    window.scrollTo(0, 0);
    scrollToHash();
});

document.addEventListener("click", (e) => {
    const link = e.target.closest('.h-nav a[href*="#"]');
    if (!link) return;
    const url = new URL(link.href);
    const isSamePage =
    url.pathname === location.pathname && url.origin === location.origin;
    if (!isSamePage) return;
    e.preventDefault();
    history.pushState(null, "", url.hash);
    scrollToHash();
});

window.addEventListener("hashchange", scrollToHash);
